/**
 * @graphql agg
 */
import { graphql } from 'react-relay';

export const PremiumTrialEotQuery = graphql`
	query PremiumTrialEotQuery($cloudId: ID!) {
		license {
			billingSourceSystem
			trialEndDate
		}
		tenantContexts(cloudIds: [$cloudId]) {
			entitlementInfo(hamsProductKey: "confluence.ondemand") {
				entitlement {
					transactionAccount {
						isBillToPresent
						isCurrentUserBillingAdmin
					}
					subscription {
						accountDetails {
							invoiceGroup {
								experienceCapabilities {
									configurePaymentV2 {
										isAvailableToUser
										experienceUrl
									}
								}
							}
						}
					}
				}
			}
		}
	}
`;
